import { CONFIGS, useConfigQuery } from '@buildwise/libs/configurations';
import useUserData from 'hooks/useUserData';
import RenderField from './RenderField';

function ActivityFormFields() {
  const { companyId } = useUserData();
  const { activeUniqueEntries } = useConfigQuery({
    companyId,
    configName: CONFIGS.ACTIVITY_LOG_INPUT_FIELDS.configName,
  });

  return (
    <>
      {activeUniqueEntries.map((field, index) => (
        <RenderField key={field.id} field={field} fieldIndex={index} />
      ))}
    </>
  );
}

export default ActivityFormFields;
